import { runAfterPageSettles } from '@cobliteam/utils/idle';

const GTM_ID = 'GTM-NP5W97XR';
const HUBSPOT_SCRIPT_ID = 'hs-script-loader';
const HUBSPOT_SCRIPT_URL = 'https://js.hs-scripts.com/5282301.js';

type MarketingWindow = Window & { dataLayer?: Record<string, unknown>[] };

const injectScript = (src: string, id?: string) => {
  const script = document.createElement('script');
  if (id) script.id = id;
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = src;
  document.head.appendChild(script);
};

/** GTM (Ads/Facebook pixels) and HubSpot tracking load after the initial route settles instead of in the HTML head. */
export const loadMarketingTags = () =>
  runAfterPageSettles(() => {
    const w = window as MarketingWindow;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    injectScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`);

    if (!document.getElementById(HUBSPOT_SCRIPT_ID)) injectScript(HUBSPOT_SCRIPT_URL, HUBSPOT_SCRIPT_ID);
  });
